import { jsx as f, jsxs as a } from "react/jsx-runtime";
import { c as g } from "react/compiler-runtime";
const v = (w) => {
  const t = g(17), {
    color: d,
    size: p,
    title: c
  } = w, l = d === void 0 ? "#545454" : d, e = p === void 0 ? 24 : p;
  let i;
  t[0] !== e ? (i = {
    width: e,
    height: e
  }, t[0] = e, t[1] = i) : i = t[1];
  let C;
  t[2] !== c ? (C = /* @__PURE__ */ f("title", { children: c }), t[2] = c, t[3] = C) : C = t[3];
  let o, s, h, n;
  t[4] !== l ? (o = /* @__PURE__ */ f("path", { d: "M44.5 22.0133C44.5 9.20333 34.56 0.5 23.5 0.5C12.5567 0.5 2.50001 9.01667 2.50001 22.1533C1.1 22.9467 0.166672 24.44 0.166672 26.1667V30.8333C0.166672 33.4 2.26667 35.5 4.83334 35.5H7.16667V21.2667C7.16667 12.2367 14.47 4.93333 23.5 4.93333C32.53 4.93333 39.8333 12.2367 39.8333 21.2667V37.8333H21.1667V42.5H39.8333C42.4 42.5 44.5 40.4 44.5 37.8333V34.9867C45.8767 34.2633 46.8333 32.84 46.8333 31.16V25.7933C46.8333 24.16 45.8767 22.7367 44.5 22.0133Z", fill: l }), s = /* @__PURE__ */ f("path", { d: "M16.5 26.1667C17.7887 26.1667 18.8333 25.122 18.8333 23.8333C18.8333 22.5447 17.7887 21.5 16.5 21.5C15.2113 21.5 14.1667 22.5447 14.1667 23.8333C14.1667 25.122 15.2113 26.1667 16.5 26.1667Z", fill: l }), h = /* @__PURE__ */ f("path", { d: "M30.5 26.1667C31.7887 26.1667 32.8333 25.122 32.8333 23.8333C32.8333 22.5447 31.7887 21.5 30.5 21.5C29.2113 21.5 28.1667 22.5447 28.1667 23.8333C28.1667 25.122 29.2113 26.1667 30.5 26.1667Z", fill: l }), n = /* @__PURE__ */ f("path", { d: "M37.5 19.2367C36.38 12.5867 30.5933 7.5 23.6167 7.5C16.5467 7.5 8.94 13.3567 9.54667 22.55C15.31 20.1933 19.65 15.06 20.8867 8.80667C23.9433 14.9433 30.22 19.1667 37.5 19.2367Z", fill: l }), t[4] = l, t[5] = o, t[6] = s, t[7] = h, t[8] = n) : (o = t[5], s = t[6], h = t[7], n = t[8]);
  let r;
  return t[9] !== e || t[10] !== i || t[11] !== C || t[12] !== o || t[13] !== s || t[14] !== h || t[15] !== n ? (r = /* @__PURE__ */ a("svg", { width: e, height: e, viewBox: "0 0 47 43", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: i, children: [
    C,
    o,
    s,
    h,
    n
  ] }), t[9] = e, t[10] = i, t[11] = C, t[12] = o, t[13] = s, t[14] = h, t[15] = n, t[16] = r) : r = t[16], r;
};
export {
  v as default
};
